import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {MessageViewModel} from '../viewmodel/MessageViewModel';
import {BotatoChatMessageDirective} from './botato-chat-message.directive';
import {BotatoChatMessageResolverService} from './botato-chat-message-resolver.service';
import {BotatoChatManagerService} from '../service/botato-chat-manager.service';
import {CommunicationService} from '../service/communication.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'botato-chat-message',
    templateUrl: './botato-chat-message.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BotatoChatMessageComponent implements OnInit, OnDestroy {

    @ViewChild(BotatoChatMessageDirective, {static: true})
    public messageHost!: BotatoChatMessageDirective;

    @Input()
    public message!: MessageViewModel;

    private communicationServiceMessageSentSubscription!: Subscription;
    private communicationServiceEventSentSubscription!: Subscription;

    constructor(private chatManagerService: BotatoChatManagerService,
                private resolver: BotatoChatMessageResolverService,
                private communicationService: CommunicationService) {
    }

    public ngOnInit(): void {
        const componentRef = this.messageHost.viewContainerRef.createComponent(this.resolver.resolve(this.message.type));
        const componentInstance = componentRef.instance;
        componentInstance.message = this.message;
        componentInstance.registerRenderingCompletedCallback(() => this.chatManagerService.scrollToBottomOfMessage(this.message.id, this.message.shouldSmoothScrollToBottomAfterRendering));
        this.communicationServiceMessageSentSubscription = this.communicationService.messageSent.subscribe(() => componentInstance.onAnyMessageSent());
        this.communicationServiceEventSentSubscription = this.communicationService.eventSent.subscribe(() => componentInstance.onAnyEventSent());
    }

    public ngOnDestroy(): void {
        this.communicationServiceMessageSentSubscription.unsubscribe();
        this.communicationServiceEventSentSubscription.unsubscribe();
    }

}
